import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";
import { Site } from "./site";

export class Zone {
  zoneId: number;
  isActif: boolean;
  nom: string;
  siteId: number;
  site: Site;
  burden: number | null;
  spacing: number | null;
  minBurden: number | null;
  diameter: number | null;
  inclination: number | null;
  subdrill: number | null;

  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('isActif', 'GLOBAL.ACTIF', '',
      new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    return tab;
  }
}
